module.exports = __webpack_public_path__ + "static/media/endpoint.4d5ef505.png";